import { periodColumn } from 'components/columns';
import { BlockWidget, BoundStates, ClientTitle } from 'components';
import { sepFormat } from 'utilities';
import type { ListBlock } from 'modules/campaign/block/types';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';
import { BlockStatusTag } from 'modules/campaign/status/BlockStatusTag';

const sumProps = {
  width: 100,
  cellProps: {
    textAlign: 'end' as const,
    className: 'px-1',
  },
};

export const columns: ControlledTableColumns<ListBlock> = [
  flexColumn({
    content: 'Block',
    key: 'code',
    required: true,
    cellProps: { className: 'py-1' },
    sortable: true,
    render: (block: ListBlock) => <BlockWidget {...block} campaign_id={block.campaign.id} link target="_self" clamp />,
  }),
  {
    content: 'Status',
    width: 100,
    key: 'status',
    cellProps: {
      textAlign: 'left',
    },
    // sortable: true,
    render: ({ status }) => <BlockStatusTag appearance="naked" status={status} />,
  },

  flexColumn({
    content: 'Client',
    key: 'client',
    cellProps: { className: 'py-1' },
    render: ({ campaign }) => <ClientTitle {...campaign} />,
  }),
  periodColumn,
  {
    ...sumProps,
    content: 'Income',
    key: 'sums.income_total',
    render: ({ sums }) => sepFormat(sums ? sums.income_total : null),
    sortable: true,
  },
  {
    ...sumProps,
    content: 'Expense',
    key: 'sums.expense_total',
    render: ({ sums }) => sepFormat(sums ? sums.expense_total : null),
    sortable: true,
  },

  {
    ...sumProps,
    content: 'Revenue',
    key: 'sums.revenue',
    sortable: true,
    render: ({ sums }) => sepFormat(sums ? sums.revenue : null),
  },
  {
    width: 64,
    cellProps: {
      textAlign: 'center',
    },
    key: 'sums',
    configLabel: 'Bound States',
    render: ({ sums }: ListBlock) => (sums ? <BoundStates {...sums} /> : null),
  },
];
